/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { TextField } from '@shopify/polaris';
import { RenderLabelTooltip } from 'src/components/views/common/forms/render-label-tooltip';

export const RenderTextFieldPrefix = (field: Object) => {
  const [existError, setExistError] = useState('');
  const {
    input,
    ruleId,
    textError,
    singularError,
    checkDuplicateTerm,
    duplicateTerm,
    onChange,
    isAppliedSingularAndPlurals
  } = field;
  let { value } = input;
  value = _.isNil(value) ? value : value.toString();

  let previewInterval = null;
  React.useEffect(() => {
    if (!value) {
      return;
    }
    // eslint-disable-next-line
    previewInterval = setTimeout(() => {
      checkDuplicateTerm({
        searchTerm: value,
        isAppliedSingularAndPlurals,
        exceptId: ruleId
      })
    }, 500);
    return () => clearTimeout(previewInterval);
  }, [value]);

  useEffect(() => {
    if (duplicateTerm[value] && duplicateTerm[value].isExists) {
      const error = duplicateTerm[value].type === "duplicated_singular" ? singularError : textError;
      setExistError(error);
    } else {
      setExistError('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duplicateTerm]);

  useEffect(() => {
    if (!value) {
      return;
    }
    checkDuplicateTerm({
      searchTerm: value,
      isAppliedSingularAndPlurals,
      exceptId: ruleId
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAppliedSingularAndPlurals])

  const isError = !!field.meta.error && !!field.meta.touched ? field.meta.error : existError;
  return (
    <div className="textfield-with-prefix">
      <RenderLabelTooltip label={field.label} tooltip={field.tooltip} />
      <TextField
        id={field.input.name}
        value={value}
        type={field.type}
        min={field.min}
        prefix={field.prefix}
        onChange={e => {
          setExistError('');
          onChange && onChange(e, field.input.name)
          field.input.onChange(e);
        }}
        onFocus={field.input.onFocus}
        placeholder={field.placeholder ? field.placeholder : ''}
        error={isError}
        onBlur={e => {
          field.input.onBlur(e);
        }}
        {...field.anotherProps}
      />
    </div>
  );
};
